<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import theme from 'mixins/theme'

export default {
  name: 'App',
  mixins: [ theme ],
  errorCaptured(err,vm,info) {
    this.$store.dispatch('storeError', `cat EC: ${err?.toString()}\ninfo: ${info}`)
    return window.config?.node_env !== 'production'
  },
  methods: {
    finishLoadingContent(props) {
      props?.forEach((typeAction) => {
        this.$store.dispatch(typeAction, { acl: this.$acl })
      })
    },
  },
  mounted() {
    this.$root.$on('finishLoadingContent', this.finishLoadingContent)
  },
  beforeDestroy() {
    this.$root.$off('finishLoadingContent', this.finishLoadingContent)
  },
}
</script>
